<template>
  <button :style="style"
          class="lbs-uscope-toolbar-button"
          :title="title"
          @click.prevent.stop="onClick"/>
</template>

<script>
  export default {
    props: {
      onClick: {type: Function, required: true},
      title: {type: String, required: true},
      icon: {type: String, required: true}
    },

    computed: {
      style () {
        return {
          'background-image': `url(${this.icon})`
        };
      }
    }
  };
</script>

<style lang="scss" scoped>
    $toolbar-button-height: 24px;
    $border-color: #b4c8da;

    .lbs-uscope-toolbar-button {
        margin: 2px;
        width: $toolbar-button-height;
        height: $toolbar-button-height;
        border: 1px solid transparent;
        outline: none;
        padding: 0;
        background-size: cover;
        background-color: transparent;

        &:hover {
            border: 1px solid $border-color;
        }
        &:active {
            border: 2px solid $border-color;
        }
    }
</style>



// WEBPACK FOOTER //
// src/uScope/js/components/vue/toolbar-button.vue